import { useQuery } from 'react-query';

import { permConst } from '../../constants/permConst';
import { isAuthorized } from '../../utils/userUtils';
import { formatAssetStatus, formatAssetType } from '../../utils/assetUtils';
import { assetConst } from '../../constants/assetConstants';
import { getAssetApprovalList } from '../../services/productsService';


export const getPermissionsForAssets = (userProfile) => {
	return {
		showMarketingTab: isAuthorized(userProfile.permissions, [
			permConst.PRODUCT.ASSET.MARKETING.VIEW.ALL
		]),
		showPackagingTab: isAuthorized(userProfile.permissions, [
			permConst.PRODUCT.ASSET.PACKAGING.VIEW.ALL
		]),
		showCodeInBoxTab: isAuthorized(userProfile.permissions, [
			permConst.PRODUCT.ASSET.CODEINBOX.VIEW.ALL
		]),
		showMarketingEventTab: isAuthorized(userProfile.permissions, [
			permConst.MARKETING_EVENT.PRODUCT.ASSET.REVIEW.MANAGER,
			permConst.MARKETING_EVENT.PRODUCT.ASSET.REVIEW.COORDINATOR,
		]),
		showDCRequestTab: isAuthorized(userProfile.permissions, [
			permConst.PRODUCT.COMPONENT.CIB.REQUEST.APPROVE.ALL,
			permConst.PRODUCT.COMPONENT.CIB.REQUEST.REVIEW.ALL,
		]),
		showDeclaredPriceTab: isAuthorized(userProfile.permissions, [
			permConst.PRODUCT.COMPONENT.DECLARED_PRICE.REQUEST.APPROVE.ALL,
			permConst.PRODUCT.COMPONENT.DECLARED_PRICE.REQUEST.REVIEW.ALL,
		])
	};
};

export function generateAssets(assets) {
	if (assets && assets.length > 0) {
		return assets.map((asset) => {
			asset.review_status = formatAssetStatus(asset.review_status);
			return asset;
		});
	}

	return [];
}

export const assetTypeCustomEvaluation = (value, filters) => {
	if (
		Object.keys(assetConst.TYPE).some(
			(type) => value === type && filters.has(formatAssetType(type)),
		)
	) {
		return true;
	}
	return false;
};

export const useAssetQuery = (options) =>
	useQuery('getAssetApprovalList', () => getAssetApprovalList(), options);
